export default __webpack_public_path__ + "static/media/chemistry.572c4439.svg";